import React, { useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { FmTextField } from "../FmTextField";
import classNames from "classnames";

import useStyles from "./FmAutocompleteInputManaged.style";
import { FmTextFieldManaged } from "..";

interface FmAutocompleteInputManagedProps {
    data: Array<any>;
    getLabel: (option: any) => string;
    inputProps?: any;
    label: string;
    onSelect?: (item: any) => void;
}

const fontWeights = {
    regular: 400,
    highlighted: 700,
};

const FmAutocompleteInputManaged = React.forwardRef<any, FmAutocompleteInputManagedProps>((props, ref) => {
    const { data, label, getLabel, inputProps, onSelect, ...rest } = props;
    const { value } = inputProps || {};

    const onChange = (e: React.SyntheticEvent, option: any) => {
        return onSelect && onSelect(option);
    };

    return (
        <Autocomplete
            {...rest}
            options={data}
            getOptionLabel={(option) => getLabel(option)}
            value={value}
            onChange={(e, value) => onChange(e, value)}
            renderInput={(params) => {
                return <FmTextFieldManaged label={label} inputRef={ref} variant={"filled"} {...inputProps} {...params} />;
            }}
            renderOption={(props, option, { inputValue }) => {
                const matches = match(getLabel(option), inputValue);
                const parts = parse(getLabel(option), matches);

                return (
                    <li {...props}>
                        <div>
                            {parts.map((part, index) => (
                                <span
                                    key={`${part.text}-${index}`}
                                    style={{
                                        fontWeight: part.highlight ? fontWeights.highlighted : fontWeights.regular,
                                    }}
                                >
                                    {part.text}
                                </span>
                            ))}
                        </div>
                    </li>
                );
            }}
        />
    );
});

export default FmAutocompleteInputManaged;
